function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Material imports
import TextField from "@mui/material/TextField";
//Limitless imports
import { withi18n } from "../../../../customer/components";
const TextInput = ({
  t,
  textInputClasses,
  placeholder,
  label,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(TextField, _extends({
    InputProps: {
      classes: textInputClasses
    },
    variant: "outlined",
    placeholder: t(placeholder),
    label: t(label),
    style: {
      marginTop: 1
    }
  }, rest));
};
export default withi18n(TextInput);
TextInput.propTypes = {
  t: PropTypes.func.isRequired,
  textInputClasses: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string
};